var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatasetBannerRight(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 281,
    height: 72,
    viewBox: "0 0 281 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.42801 -23.2134C8.63194 113.973 190.395 -35.9359 153.003 133.252",
    stroke: "url(#paint0_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.0312 -25.2344C41.7033 93.8135 188.551 -25.7709 171.848 131.372",
    stroke: "url(#paint1_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.6289 -27.3555C74.7769 73.6519 186.798 -15.7137 190.688 129.392",
    stroke: "url(#paint2_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.2344 -29.3789C107.85 53.4895 184.956 -5.55119 209.439 127.518",
    stroke: "url(#paint3_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.832 -31.5C140.916 33.2295 183.106 4.51369 228.271 125.439",
    stroke: "url(#paint4_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.4258 -33.6211C173.881 12.977 181.252 14.5786 247.107 123.46",
    stroke: "url(#paint5_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.0312 -35.6445C206.962 -7.08683 179.418 24.8397 265.954 121.578",
    stroke: "url(#paint6_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.723 -37.7734C240.122 -27.3547 177.759 34.8891 284.888 119.59",
    stroke: "url(#paint7_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M127.328 -39.793C273.195 -47.5132 175.917 45.0555 303.736 117.712",
    stroke: "url(#paint8_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.924 -41.9168C306.267 -67.6775 174.065 55.1177 322.573 115.73",
    stroke: "url(#paint9_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.53 -43.9403C339.341 -87.84 172.224 65.2801 341.325 113.855",
    stroke: "url(#paint10_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.125 -46.0612C372.405 -108.1 170.47 75.3375 360.162 111.876",
    stroke: "url(#paint11_linear)",
    strokeWidth: 1.381,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 220.332,
    cy: 33.3297,
    r: 8,
    transform: "rotate(92.4279 220.332 33.3297)",
    fill: "url(#paint12_radial)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 8.24805,
    y1: 60.6206,
    x2: 155.501,
    y2: 49.022,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear",
    x1: 23.9528,
    y1: 58.6586,
    x2: 169.473,
    y2: 47.1964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear",
    x1: 39.5994,
    y1: 56.6561,
    x2: 185.039,
    y2: 45.2003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear",
    x1: 55.2869,
    y1: 54.7061,
    x2: 203.514,
    y2: 43.0307,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear",
    x1: 71.018,
    y1: 52.7994,
    x2: 222.313,
    y2: 40.8824,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear",
    x1: 86.7708,
    y1: 50.9079,
    x2: 241.086,
    y2: 38.753,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear",
    x1: 102.528,
    y1: 49.0301,
    x2: 259.844,
    y2: 36.6388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear",
    x1: 118.264,
    y1: 47.16,
    x2: 278.587,
    y2: 34.5319,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear",
    x1: 133.982,
    y1: 45.293,
    x2: 297.332,
    y2: 32.4265,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear",
    x1: 149.535,
    y1: 42.9143,
    x2: 316.039,
    y2: 29.7993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear",
    x1: 164.991,
    y1: 39.5251,
    x2: 334.678,
    y2: 26.1594,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear",
    x1: 180.42,
    y1: 35.68,
    x2: 353.288,
    y2: 22.0638,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDDD20"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0938292,
    stopColor: "#FDDE29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#FDE243"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4492,
    stopColor: "#FEE96C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6837,
    stopColor: "#FEF1A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9451,
    stopColor: "#FFFDEF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(218.412 29.0097) rotate(68.0704) scale(13.281)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCDC6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59375,
    stopColor: "#FBE11C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 347,
    height: 186,
    fill: "white",
    transform: "translate(0.234375 -41.0898) rotate(-4.5037)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatasetBannerRight);
export default __webpack_public_path__ + "static/media/dataset_banner-right.002631bb14d316d72f42023c5b01d06c.svg";
export { ForwardRef as ReactComponent };